import { createContext, useContext, useState, FC, ReactNode } from 'react'

interface HeaderContextType {
  title: string
  setTitle: (title: string) => void
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined)

export const useHeader = () => {
  const context = useContext(HeaderContext)
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider')
  }
  return context
}

interface HeaderProviderProps {
  children: ReactNode
}

export const HeaderProvider: FC<HeaderProviderProps> = ({ children }) => {
  const [title, setTitle] = useState('ConnectUp')

  return <HeaderContext.Provider value={{ title, setTitle }}>{children}</HeaderContext.Provider>
}
